// types
import { SectionHeaderProps } from './SectionHeader.types';

// styles
import {
  VAlignBox,
  IconBox,
  Separator
} from '../SectionToggle/SectionToggle.styles';

const SectionHeader = ({ label, icon }: SectionHeaderProps) => {
  return (
    <VAlignBox>
      {icon && <IconBox>{icon}</IconBox>}

      {label}

      <Separator />
    </VAlignBox>
  );
};

export default SectionHeader;
